import { render, staticRenderFns } from "./rolead.vue?vue&type=template&id=af0ad126&scoped=true&"
import script from "./rolead.vue?vue&type=script&lang=js&"
export * from "./rolead.vue?vue&type=script&lang=js&"
import style0 from "./rolead.vue?vue&type=style&index=0&id=af0ad126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0ad126",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af0ad126')) {
      api.createRecord('af0ad126', component.options)
    } else {
      api.reload('af0ad126', component.options)
    }
    module.hot.accept("./rolead.vue?vue&type=template&id=af0ad126&scoped=true&", function () {
      api.rerender('af0ad126', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/subaccount/components/rolead.vue"
export default component.exports